<template>
    <div>
        <div v-if="campaign != null">
            <campaign-picture
                :arrCampaignImage="campaign.pictures"
            ></campaign-picture>
            <div class="bg-gradient"></div>
            <div class="wrapper-icon-back" @click="clickBack()">
                <img
                    class="icon-back"
                    src="../../../assets/campaign/icon_back@2x.png"
                />
            </div>
            <div class="wrapper-detail">
                <div class="campaign-name">{{ campaign.name }}</div>
                <!-- <div class="campaign-expire-date" v-if="!isNews" >{{ getEnddateText() }}</div> -->
                <div class="campaign-qty2" v-show="campaign.qty > 0" >{{lbl.detail.balance}}</div>
                <div class="qty" v-show="campaign.qty > 0">
                    <div :class="getQtyPercent()"></div>
                </div>
                <div class="max-redeem" v-if="!isNews && campaign.qty <= 0">{{lbl.detail.max_redeem}}</div>
                <!-- <div class="campaign-qty" v-if="!isNews && locale == 1054" >{{lbl.detail.balance}} {{qty | number_format}} {{lbl.detail.balance_2}}</div>
                <div class="campaign-qty" v-if="!isNews && locale == 1033" >{{qty | number_format}} {{lbl.detail.balance}}</div> -->
                <detail-and-condition
                    :lbl="lbl"
                    :campaign="campaign"
                ></detail-and-condition>
            </div>

            <sub-campaign-dropdown
                :lbl="lbl"
                :subcampaign="subCampaign"
                v-if="isShowSubcampaign"
                @updateSelectedCampaignInfo="updateSelectedCampaignInfo($event)"
            ></sub-campaign-dropdown>
            <redeem
                :lbl="lbl"
                :campaign="campaign"
                :selectedId="campaignId"
                :selectedPoint="point"
                :selectedQuantity="quantity"
                @updateCampaignInfo="updateCampaignInfo($event)"
                v-if="!isNews && isEnableRedeem"
            ></redeem>
            <!-- <div class="redeem-border" v-if="isNews"></div> -->
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import Account from '@/helper/AccountHelper.js';
import CampaignPicture from "@/components/campaign/detail/Picture.vue";
import DetailAndCondition from "@/components/campaign/detail/DetailAndCondition";
import SubCampaignDropdown from "@/components/campaign/detail/SubCampaignDropDown.vue";
import Redeem from "@/components/campaign/detail/Redeem.vue";
import DatetimeHelper from "@/helper/DatetimeHelper.js";

/**
 * Property
 * @property {object} lbl (required) Text for component.
 * @property {number} locale (required) Current language.
 * @property {object} campaign (required) Campaign information.
 * Method
 * @method initialLayout Setup campaign information.
 * @method updateSelectedCampaignInfo Callback for subcampagin to update Campaign information.
 */
export default {
    name: "DefaultLayout",
    components: {
        CampaignPicture,
        DetailAndCondition,
        SubCampaignDropdown,
        Redeem
    },
    props: {
        lbl: Object,
        locale: Number,
        campaign: Object
    },
    data: function() {
        return {
            isLogin: false,
            campaignId: "",
            quantity: 0,
            point: 0,
            price: 0,
            originPrice: 0,
            discount: 0,
            qty: 0,
            expireDate: null,

            isShowSubcampaign: false,
            subCampaign: null,

            isNews: false,
            isEnableRedeem: true
        };
    },
    created: function() {
        if (this.$route.params.form == "history") {
            this.isEnableRedeem = false;
        }
        Account.loginStatus().then((status) => {
            this.isLogin = status;
        });
        this.initialLayout();
    },
    methods: {
        initialLayout: function() {
            if (this.campaign.subCampaignStyles) {
                this.isShowSubcampaign = true;
                this.subCampaign = this.campaign.subCampaignStyles.styles;

                var firstsubcampaign = this.campaign.subCampaignStyles
                    .styles[0];
                if (firstsubcampaign.subitems[0].value != "none")
                    firstsubcampaign = firstsubcampaign.subitems[0];

                this.updateSelectedCampaignInfo(firstsubcampaign);
            } else {
                this.updateSelectedCampaignInfo();
            }
            if (Vue.CampaignType.News == this.campaign.type) {
                this.isNews = true;
            }
        },
        getPointText: function() {
            var pointTypeTxt =
                this.campaign.pointType && this.campaign.pointType != "use"
                    ? this.lbl.detail.get_point
                    : this.lbl.detail.use_point;

            var point =
                this.locale === 1033 && this.point > 1
                    ? this.lbl.detail.point + "s"
                    : this.lbl.detail.point;

            return pointTypeTxt + this.point + " " + point;
        },
        getQTYText: function() {
            return this.qty + " " + this.lbl.detail.balance;
        },
        getEnddateText: function() {
            return (
                this.lbl.detail.expire_date +
                " " +
                DatetimeHelper.dateFullFormat(this.expireDate)
            );
        },
        updateCampaignInfo: function(campaign) {
            this.campaign.updateCampaign(campaign);
            this.initialLayout();
        },
        updateSelectedCampaignInfo: function(selectedItem) {
            if (selectedItem) {
                this.campaignId = selectedItem.campaignId;
                this.quantity =
                    selectedItem.quantity - (selectedItem.itemCountSold || 0);
                this.point = selectedItem.points || selectedItem.point || 0;
                this.price = selectedItem.price;
                this.originalPrice = selectedItem.originalPrice;
                this.discount = selectedItem.discount;
                this.qty = selectedItem.qty;
                this.expireDate = this.campaign.expireDate;
            } else {
                this.campaignId = this.campaign.id;
                this.quantity = this.campaign.qty;
                this.point = this.campaign.pointPerUnit;
                this.price = this.campaign.pricePerUnit;
                this.originalPrice = this.campaign.originalPrice;
                this.discount = this.campaign.discount;
                this.qty = this.campaign.qty;
                this.expireDate = this.campaign.expireDate;
            }
        },
        clickBack: function() {
            var path = "/";
            var CachecampaignID = Account.getCacheCustom('campaignId');

            var gtm = {
                 "event_label": "back_from_privilege_detail",
                 "timestamp": DatetimeHelper.getDateTimeGTM()
            };

            Vue.ga.event(this, "privilege", "click_buttons", gtm.event_label, null, gtm);

            if (this.$route.params.form == "history") {
                this.$router.push({ name: 'history'});
            } else if (!this.isLogin) {
                path = "/campaign/" + this.campaign.id + "?command=close";
                this.$router.push(path);
            } else if (CachecampaignID) {
                var isPopup = Account.isPopup();
                if (isPopup == "true") {
                    path = "/campaign/" + this.campaign.id + "?command=close&popup=true";
                } else {
                    path = "/campaign/" + this.campaign.id + "?command=close";
                }
                this.$router.push(path);
            } else {
                this.$router.push({ name: 'home'});
            }


            //this.$router.push(path);
        },
        getQtyPercent: function () {

            var percent = parseInt(this.campaign.qty * 100 / this.campaign.quantity);

            if (percent > 30) {
                return "count-qty-green";
            } else if (percent > 10 && percent <= 30) {
                return "count-qty-yellow";
            } else {
                return "count-qty-red";
            }

        }

    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/common.scss";

.bg-gradient {
    width: 100vw;
    height: 50px;
    position: absolute;
    top: 0;
    left: 0;
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0,0) 100%);
}

.wrapper-icon-back {
    width: 13px;
    height: 35px;
    position: absolute;
    top: 15px;
    left: 20px;
    z-index: 1;

    .icon-back {
        width: 100%;
        z-index: 2;
    }
}

.wrapper-detail {
    padding: 30px 30px 105px 30px;
    background-color: white;
    border-radius: 30px 30px 0 0;
    margin-top: -40px;
    overflow: hidden;
    position: relative;
    min-height: calc(100vh - 210px);

    .campaign-name {
        color: $black-default;
        font-weight: bold;
        line-height: 1;
        margin-bottom: 7px;
        font-size: 26px;

    }

    .campaign-expire-date {
        color: $black-default;
        font-size: 17px;
        line-height: 0.9em;
        margin-bottom: 15px;
    }

    .campaign-qty {
        font-weight: 500;
        font-size: 22px;
        line-height: 0.9em;
        color: $primery-color;
    }
    .max-redeem {
        font-weight: 500;
        font-size: 22px;
        line-height: 0.9em;
        color: red;
    }
    .campaign-qty2 {
        color: #232020;
        margin-top: 20px;
        font-size: 20px;
        font-weight: 500;

    }

    .qty {
        position: relative;
        margin-top: 5px;
        width: 50%;
        background-color: #E5E5E5;
        height: 8px;
        border-radius: 10px;

        .count-qty-green{
            border-radius: 10px;
            width: 100%;
            height: 8px;
            background-color: #5BBF0D;;
        }
        .count-qty-yellow{
            border-radius: 10px;
            width: 50%;
            height: 8px;
            background-color: #FFBD14;
        }
        .count-qty-red{
            border-radius: 10px;
            width: 20%;
            height: 8px;
            background-color: #EE2D24;
        }
    }
}

.redeem-border {
    width: 40%;
    height: 8px;
    margin-top: -25px;
    background-color: $black-default;
    border-radius: 3px;
    margin-left: 30%;
    position: relative;
}
</style>
